<template>
  <div class="licenses__wrapper">
    <Accordion
      v-for="(childItem, index) in licenses"
      :id="childItem.tid"
      :key="index"
      :full="true"
      :dir-button="true"
      :dir-button-left="true"
      :title="childItem.name"
      :pid="jurisdiction"
      :jurisdiction-parent="jurisdictionParent"
      size="accordion-heading"
      level="license"
      @loadLicenses="loadLicenses"
    >
      <client-only>
        <RequirementsList
          v-if="childItem.requirements && childItem.requirements.length > 0"
          :jurisdiction="jurisdiction"
          :category-parent="childItem.tid"
          :requirements="childItem.requirements"
        />
        <div v-else class="loading-data">Loading Requirements...</div>
      </client-only>
    </Accordion>
  </div>
</template>

<script>
export default {
  name: "LicenseList",
  components: {
    Accordion: () => import("../elements/Accordion"),
    RequirementsList: () => import("../elements/RequirementList"),
  },
  props: {
    jurisdiction: {
      type: Number,
      default: null,
    },
    jurisdictionParent: {
      type: Number,
      default: null,
    },
    licenses: {
      type: Array,
      default: null,
    },
    queryParams: {
      type: String,
      default: "",
    },
    countryState: {
      type: Number,
      default: null,
    },
  },
  methods: {
    loadLicenses(id, pid, jurisdictionParent, level) {
      let filter = `filter[jurisdiction]=${pid}&filter[licences]=${id}`;
      if (this.queryParams) {
        filter += "&" + this.queryParams;
      }

      this.$store
        .dispatch("Requirement/getData", {
          url: `/requirements-tree-terms?${filter}`,
          label: "requirementsTree",
        })
        .then(({ data }) => {
          this.$store.commit("Requirement/insertRequirementData", {
            label: "requirementsTree",
            data,
            id,
            pid,
            countryState: this.countryState,
            jurisdictionParent,
          });
        });
    },
  },
};
</script>

<style scoped lang="scss">
@import "../../assets/styles/helpers/variables";
@import "../../assets/styles/helpers/mixin";

.licenses {
  &__wrapper {
    margin-left: 0rem;
  }

  &__body {
    // padding-top: 3rem;
    margin-left: 3rem;

    .heading {
      font-size: 2.2rem;
      font-weight: bold;
    }
  }

  &__inner {
    // padding-top: 3rem;
    padding-left: 7.4rem;
    border-left: dotted 1px $border;
    padding-top: 3rem;

    .heading {
      font-size: 1.8rem;
      font-weight: 700;
    }
  }
}

.loading-data {
  font-size: 1.8rem;
  text-align: center;
  width: 100%;
}
</style>
